import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupUpdateInfoContentProps } from './msg-group-update-info-content';
import { MsgGroupUpdateInfoContent } from './msg-group-update-info-content';

export interface MsgGroupUpdateInfoPreviewProps extends MsgGroupUpdateInfoContentProps {}

export const MsgGroupUpdateInfoPreview = memo(function MsgGroupUpdateInfoPreview({
  message,
}: MsgGroupUpdateInfoPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupUpdateInfoContent message={message} />
    </LastMessageSystem>
  );
});
